export const MapConfigPro = {
    options: {
        //地圖基礎設定
        zoom: 7,
        minZoom: 5,
        maxZoom: 14,
        maxBounds: [
            [32, 110],
            [10, 150]
        ], //地圖鎖定範圍: 左上,右下
        center: [23.8, 121.12], // 臺灣
        zoomControl: false
        // renderer: L.canvas()
    },
    ctrl: {
        panes_tag_delete_btn: false,
    },
    button: {
        //地圖按鈕
        zoom_in: [{
            name: 'zoom_in',
            title: '拉近'
        }],
        zoom_out: [{
            name: 'zoom_out',
            title: '拉遠'
        }],
        small_area: [{
            name: 'small_area',
            title: '臺灣'
        }],
        large_area: [{
            name: 'large_area',
            title: '東亞'
        }],
        basemap_boundary: [{
            name: 'boundary',
            title: '地圖設定'
        }],
        measure: [{
            name: 'measure',
            title: '測量工具',
        }],
        capture: [
            {
                name: 'capture',
                title: '儲存影像'
            }
        ]
    },
    area_bounds: {
        // 臺灣周遭的範圍：東經119度~123度 、北緯21度~26度
        small_area: [
            [21, 119],
            [26, 123]
        ],
        // 東亞的範圍：東經110~160、北緯5度~40度
        large_area: [
            [32, 110],
            [10, 150]
        ]
    },
    basemap_boundary: [
        {
            default: ['county', 'coastline'],
            item: {
                subtitle: {
                    name: '地理資訊',
                    icon: 'boundary',
                },
                list: [
                    { name: 'county', text: '縣市 County' },
                    { name: 'coastline', text: '海岸線 Coastline' },
                    { name: 'lonlat', text: '經緯線 Latitude and longitude' }
                ],
            },
            setting: {
                county: {
                    url: '/static/map_geojson/CWA_Zone.geojson',
                    pane_order: 1,
                    style: {
                        color: '#FFF', //預設顏色
                        weight: 1.5,
                        fillOpacity: 0
                    },
                    // 切換地圖時變動顏色
                    // 預設地圖若屬於dark mode, dark顏色請設定同style.color
                    color_bind_map: {
                        light: '#e6a23c',
                        dark: '#FFF'
                    }
                },
                coastline: {
                    url: '/static/map_geojson/coastline.json',
                    style: {
                        color: '#ffff9c',
                        weight: 1.5
                    },
                    color_bind_map: {
                        light: '#e6a23c',
                        dark: '#ffff9c'
                    }
                },
                lonlat: {
                    status: false,
                    text: '經緯線',
                    url: '/static/map_geojson/lonlat.geojson',
                    pane_order: 1,
                    style: {
                        color: "#777",
                        weight: 1
                    }
                },
                lonlat_1: {
                    status: false,
                    url: '/static/map_geojson/lonlat_1.geojson',
                    pane_order: 1,
                    style: {
                        color: "#777",
                        weight: 1
                    }
                },
                lonlat_5: {
                    status: false,
                    url: '/static/map_geojson/lonlat.geojson',
                    pane_order: 1,
                    style: {
                        color: "#777",
                        weight: 1
                    }
                },
                lonlat_10: {
                    status: false,
                    url: '/static/map_geojson/lonlat_10.geojson',
                    pane_order: 1,
                    style: {
                        color: "#777",
                        weight: 1
                    }
                }
            }
        },
        {
            //底圖選項, 可切換
            default: 'black',
            item: {
                subtitle: {
                    name: '地圖樣式',
                    icon: 'basemap',
                },
                list: [
                    { name: 'osm_zh', text: 'OpenStreetMap(中文)' },
                    { name: 'nls_color', text: '臺灣通用電子地圖(彩色)' },
                    { name: 'nls_black', text: '臺灣通用電子地圖(黑色)' },
                    { name: 'black', text: 'QPEplus預設地圖(黑色)' }
                ]
            }
        }
    ],
    basemap: {
        //底圖選項, 可切換
        default: 'black',
        list: [
            { name: 'osm_zh', text: 'OpenStreetMap(中文)' },
            { name: 'nls_color', text: '臺灣通用電子地圖(彩色)' },
            { name: 'nls_black', text: '臺灣通用電子地圖(黑色)' },
            { name: 'black', text: 'QPEplus預設地圖(黑色)' }
        ]
    },
    boundary: {
        default: ['county', 'coastline'],
        list: [
            { name: 'county', text: '縣市 County' },
            { name: 'coastline', text: '海岸線 Coastline' },
            { name: "lonlat_1", text: "經緯線1度 Latitude and longitude 1°" },
            { name: "lonlat_5", text: "經緯線5度 Latitude and longitude 5°" },
            { name: "lonlat_10", text: "經緯線10度 Latitude and longitude 10°" }
        ],
        setting: {
            county: {
                url: '/static/map_geojson/CWA_Zone.geojson',
                pane_order: 1,
                style: {
                    color: '#FFF', //預設顏色
                    weight: 1.5,
                    fillOpacity: 0
                },
                // 切換地圖時變動顏色
                // 預設地圖若屬於dark mode, dark顏色請設定同style.color
                color_bind_map: {
                    light: '#e6a23c',
                    dark: '#FFF'
                }
            },
            coastline: {
                url: '/static/map_geojson/coastline.json',
                style: {
                    color: '#ffff9c',
                    weight: 1.5
                },
                color_bind_map: {
                    light: '#e6a23c',
                    dark: '#ffff9c'
                }
            },
            lonlat_1: {
                status: false,
                url: '/static/map_geojson/lonlat_1.geojson',
                pane_order: 1,
                style: {
                    color: "#777",
                    weight: 1
                }
            },
            lonlat_5: {
                status: false,
                url: '/static/map_geojson/lonlat_5.geojson',
                pane_order: 1,
                style: {
                    color: "#777",
                    weight: 1
                }
            },
            lonlat_10: {
                status: false,
                url: '/static/map_geojson/lonlat_10.geojson',
                pane_order: 1,
                style: {
                    color: "#777",
                    weight: 1
                }
            }
        }
    },
    measure_tool: {
        title: '測量工具',
        finish_btn_txt: '計算面積',
        clear_text: '清空',
        order_tool: false,
        opacity_tool: false,
        pane_tag_tool: false,
    },
    pane_text: {
        basemap_boundary: '地理界線'
    }
};
